export const requiredField = {
  message: 'This field is required',
};
export const requiredTextField = {
  value: /^[a-zA-Z]+$/,
  message: 'Please enter a valid name, only alphabets!',
};

export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i,
  message: 'Please enter a valid email Id',
};

export const urlPattern = {
  value:
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  message: 'Please enter a valid web url',
};

export const phonePattern = {
  // value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
  value: /^\(\d{3}\)\d{3}-\d{4}$/,
  message: 'Please provide a valid phone number.',
};

export const passwordPattern = {
  value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  message:
    'Password must contain at least eight characters, including uppercase, lowercase, numbers and special character',
};

export const otpPattern = {
  value: /^[0-9]{6,6}$/,
  message: 'Password should be of 6 digits',
};
